import { ReactNode } from "react";
import { cn } from "../../ClassName";

interface Props {
  className?: string;
  children?: ReactNode;
  id?: string;
  "data-testid"?: string;
}

export function P3(props: Props) {
  const defaultStyling = {
    "tw-font-sans": true,
    "tw-font-normal": true,
    "tw-text-[12px]": true,
    "tw-text-gray-0": true,
  };

  return (
    <p
      className={cn(defaultStyling, props.className)}
      id={props.id}
      data-testid={props["data-testid"]}
    >
      {props.children}
    </p>
  );
}
